/* GENERATED from design-system/assets/icons/chevron-right.svg — do not edit.
 * Regenerate: node design-system/scripts/build-assets.mjs */
import * as React from "react";
import type { IconProps } from "./props";
const ChevronRight = ({ size, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? "1em"}
    height={size ?? "1em"}
    {...props}
  >
    <path
      d="M9 6L15 12L9 18"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ChevronRight;
